import axios from "../../config/axiosConfig";
import {
  CREATE_PALLET_RECEIVE, DELETE_PALLET_RECEIVE,
  GET_PALLET_RECEIVE,
  PALLET_RECEIVE_REQUEST,
  PALLET_RECEIVE_REQUEST_FAILURE,
  UPDATE_PALLET_RECEIVE,
  GET_PALLET_RECEIVES_PAGE,
  PALLET_RECEIVE_REQUEST_SUCCESS,
} from "../types/pallet-receive-types";


export const getPalletReceivesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Purchase_Account_Id'
      };
      return axios.get("/pallet-receive/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PALLET_RECEIVES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPalletReceiveById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
    
      return axios.get(`/pallet-receive/get/${id}`).then((response) => {
        dispatch({ type: PALLET_RECEIVE_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPalletReceiveBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/pallet-receive/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: PALLET_RECEIVE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPalletReceivesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/pallet-receive/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPalletReceive = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/pallet-receive/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PALLET_RECEIVE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createPalletReceive = (palletReceive) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      const newPalletReceive = {
        ...palletReceive
      };
      return axios.post("/pallet-receive/add", newPalletReceive,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PALLET_RECEIVE, payload: response.data });
        } else {
          dispatch({
            type: PALLET_RECEIVE_REQUEST_FAILURE,
            error: "Job Yarn Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePalletReceive = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.put("/pallet-receive/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PALLET_RECEIVE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PALLET_RECEIVE_REQUEST_FAILURE,
            error: "Job Yarn Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePalletReceive = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PALLET_RECEIVE_REQUEST });
      return axios.delete(`/pallet-receive/delete/${id}`).then((response) => {
        if (response.data) {
          const include = ['id', 'Vch_No', 'P_Challan_No', 'Date', 'Narration', 'Account_Id', 'Purchase_Account_Id'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.palletReceive || {};
          dispatch(getPalletReceivesWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
          dispatch({ type: DELETE_PALLET_RECEIVE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PALLET_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
